// src/ProductForm.js
import React, { useEffect, useState } from "react";

export default function ProductForm({ onCreate, onUpdate, editing, onCancel }) {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");

  useEffect(() => {
    if (editing) {
      setName(editing.name || "");
      setPrice(editing.price || "");
      setQuantity(editing.quantity ?? "");
    } else {
      setName("");
      setPrice("");
      setQuantity("");
    }
  }, [editing]);

  const submit = (e) => {
    e.preventDefault();
    const data = { name, price: Number(price || 0), quantity: Number(quantity || 0) };
    if (editing) {
      onUpdate(editing.id, data);
    } else {
      onCreate(data);
    }
  };

  return (
    <form onSubmit={submit}>
      <input placeholder="Name" value={name} onChange={e=>setName(e.target.value)} />
      <input placeholder="Price" value={price} onChange={e=>setPrice(e.target.value)} />
      <input placeholder="Quantity" value={quantity} onChange={e=>setQuantity(e.target.value)} />
      <button type="submit" className="btn btn-primary">
        {editing ? "Update" : "Create"}
      </button>
      {editing && (
        <button type="button" onClick={onCancel} className="btn">Cancel</button>
      )}
    </form>
  );
}
